import { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { db } from '../../../integrations/firebase';

// Partial-COD config from Storefront Settings (userFilters/shopSettings.partialCod).
//
// The advance field is ALWAYS offered on a COD order — an advance of 0 just means
// a normal full-COD order, so there is nothing to gate. The only thing settings
// decide is whether the field starts pre-filled: defaultAdvance 0 (the default)
// means staff type an amount when they want one; a non-zero default pre-fills it.
//
// Settings are read best-effort: if the read fails the field still shows, blank.
export const usePartialCodConfig = () => {
    const [cfg, setCfg] = useState({ defaultAdvance: 0, loaded: false });
    useEffect(() => {
        let alive = true;
        get(ref(db, 'userFilters/shopSettings/partialCod'))
            .then((sn) => {
                if (!alive) return;
                const v = sn.exists() ? sn.val() : {};
                setCfg({ defaultAdvance: Math.max(0, Math.round(Number(v.defaultAdvance) || 0)), loaded: true });
            })
            .catch(() => { if (alive) setCfg((p) => ({ ...p, loaded: true })); });
        return () => { alive = false; };
    }, []);
    return cfg;
};
